// CORE
import { useContext } from "react";

// THIRD-PARTY LIBRARIES
import { Col, Form } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";

// COMPONENTS
import InputTitle from "components/Form/input-title";
import InputGroupFieldError from "../error-field-group/InputGroupFieldError";
import { Context } from "components/Form";

// ASSETS (SVGs)
import { ReactComponent as ArrowDownIcon } from "./assets/arrow-down.svg";

// STYLES
import styles from "./styles/style.module.scss";

export const SelectGroupField = ({
    parentName,
    index,
    input,
    labelName = "label",
    valueName = "value",
    rules = { required: <FormattedMessage id="requiredField" /> },
    lg = "12",
    ...reset
}) => {
    const { locale, formatMessage } = useIntl();
    const { register, errors } = useContext(Context);
    if (!input?.options) return "";

    return (
        <Col lg={lg}>
            <div
                className={`${styles["select-field-group"]} ${
                    rules?.required ? "required" : ""
                }`}
            >
                <InputTitle name={input?.langId ?? input?.name} />

                <div className="select-container">
                    <Form.Select
                        className="select-input"
                        {...register(
                            `${parentName}.${index}.${input?.name}`,
                            rules
                        )}
                        {...reset}
                    >
                        {input?.placholder ? (
                            <option value={""} hidden disabled>
                                {formatMessage({ id: input?.placholder })}
                            </option>
                        ) : (
                            ""
                        )}
                        {input?.options?.map((option) => (
                            <option
                                key={option?.[valueName]}
                                value={option?.[valueName]}
                            >
                                {option?.[labelName]?.[locale] ||
                                    option?.[labelName]}
                            </option>
                        ))}
                    </Form.Select>
                    <ArrowDownIcon className="arrow-icon" />
                </div>
                <InputGroupFieldError
                    errors={errors}
                    index={index}
                    name={parentName}
                    input={input}
                />
            </div>
        </Col>
    );
};
